import React from "react";
import QRCode from "react-qr-code";
import styles from "./index.module.scss";

export const QrBlock = () => {
  return (
    <div className={styles.qr_compact}>
      <div className={styles.qr_box}>
        <QRCode value={window.location.href} size={64} />
      </div>
      <div>
        <p className={styles.qr_label}>QR‑код</p>
        <p className={styles.qr_title}>Открыть страницу на телефоне</p>
        <p className={styles.qr_text}>
          Если страница открыта на ПК, отсканируйте код смартфоном, чтобы
          быстро открыть платежную форму на телефоне.
        </p>
      </div>
    </div>
  );
};
